import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {
    OneToTwentyFiveFilterDefinition
} from "../filters-definitions/game-features/one-to-twenty-five.filter-definition";
import {
    TwentyFivePlusFilterDefinition
} from "../filters-definitions/game-features/twenty-five-plus.filter-definition";
import {NewGameFilterDefinition} from "../filters-definitions/game-features/new-game.filter-definition";
import {LowStakeFilterDefinition} from "../filters-definitions/game-features/low-stake.filter-definition";
import {HighStakeFilterDefinition} from "../filters-definitions/game-features/high-stake.filter-definition";
import {BonusGameFilterDefinition} from "../filters-definitions/game-features/bonus-game.filter-definition";
import {FreeSpinsFilterDefinition} from "../filters-definitions/game-features/free-spins.filter-definition";
import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {CategoryDefinitionId} from "./filter-category-definition.interface";
import {HasSideBetsFilterDefinition} from "../filters-definitions/game-features/has-side-bets.filter-definition";
import {IsMultiHandFilterDefinition} from "../filters-definitions/game-features/is-multi-hand.filter-definition";

export class GameFeaturesFiltersCategoryDefinition extends FilterCategoryDefinitionBase {
    get title(): string {
        return this.services.translation.translate('GAME_FEATURES');
    }

    get id(): CategoryDefinitionId {
        return 'features';
    }

    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        return [
            new OneToTwentyFiveFilterDefinition(this.services),
            new TwentyFivePlusFilterDefinition(this.services),
            new NewGameFilterDefinition(this.services),
            new LowStakeFilterDefinition(this.services),
            new HighStakeFilterDefinition(this.services),
            new BonusGameFilterDefinition(this.services),
            new FreeSpinsFilterDefinition(this.services),
            new HasSideBetsFilterDefinition(this.services),
            new IsMultiHandFilterDefinition(this.services),
        ];
    }
}